/**
 * Servicio de Remisiones (AMX-VTA-FR-06)
 */

import api from './api.js';

class RemisionService {
  async listar(params = {}) {
    return await api.get('/remisiones', params);
  }

  async obtenerPorId(id) {
    return await api.get(`/remisiones/${id}`);
  }

  async obtenerActivaPorTractor(numSerie) {
    return await api.get(`/remisiones/por-tractor/${encodeURIComponent(numSerie)}`);
  }

  async lookupTractor(numSerie) {
    return await api.get(`/remisiones/lookup-tractor/${encodeURIComponent(numSerie)}`);
  }

  async obtenerEstadisticas() {
    return await api.get('/remisiones/estadisticas');
  }

  async crear(data) {
    return await api.post('/remisiones', data);
  }

  async actualizar(id, data) {
    return await api.put(`/remisiones/${id}`, data);
  }

  async completar(id) {
    return await api.post(`/remisiones/${id}/completar`, {});
  }

  async cancelar(id, motivo) {
    return await api.post(`/remisiones/${id}/cancelar`, { motivo });
  }

  async eliminar(id) {
    return await api.delete(`/remisiones/${id}`);
  }
}

export default new RemisionService();
